import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAppDispatch, useAppSelector } from 'Douleutaras/redux/hooks';
import { snackbarSlice } from 'Douleutaras/redux/data/ui/snackbarSlice';
import { SnackbarItem } from 'Douleutaras/components/Snackbar/SnackbarItem';

import './Snackbar.scss';

const Snackbar = () => {
  const [mounted, setMounted] = useState(false);
  const elRef = useRef<HTMLDivElement>(undefined);
  const snackbarRoot = mounted ? document.getElementById('snackbar') : undefined;

  if (mounted && !elRef.current) {
    elRef.current = document.createElement('div');
  }

  const el = elRef.current;
  const dispatch = useAppDispatch();

  const setUp = () => {
    if (!document.body.classList.contains('snackbar--open')) {
      document.body.classList.add('snackbar--open');
      snackbarRoot.appendChild(el);
    }
  };

  const cleanUp = (element): void => {
    if (!document.body.classList.contains('snackbar--open')) {
      return;
    }
    document.body.classList.remove('snackbar--open');
    snackbarRoot.removeChild(element);
  };

  const notifications = useAppSelector(state => state.snackbar);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) {
      return;
    }
    // Will set a timer if needed to dispatch a removal
    if (typeof notifications !== 'undefined' && Array.isArray(notifications) && notifications.length > 0) {
      // add classname to body
      setUp();
      // --
      notifications.forEach(notification => {
        // if timer
        if (!notification.dismissible && notification.duration > 0 && !notification.dismissed) {
          // why we need this?
          // dispatch(snackbarSlice.actions.setSnackbarNotificationAsDismissed({ id: notification.id }));
          setTimeout(
            () => dispatch(
              snackbarSlice.actions.dismissSnackbarNotification({ id: notification.id })
            )
          , notification.duration);
        }
      });
    } else {
      // clear className
      cleanUp(el);
    }
  }, [ notifications ]);

  const visible = notifications?.filter(n => !n.dismissed) || [];

  const anyWithOffset = visible.find(n => n.offset);

  const offsetStyle = anyWithOffset
    ? { bottom: `${anyWithOffset.offset}` }
    : {};

  if (!mounted) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return createPortal(
    <div className="snackbar-wrapper" style={offsetStyle}>
      {
        visible.map(notification => <SnackbarItem id={notification.id}
                                             type={notification.type}
                                             text={notification.message}
                                             dismissible={notification.dismissible}
                                             key={`snack_${notification.id}_${notification.type}`}
                               />
          )
      }
    </div>,
    el
  );
};

export default Snackbar;
